export const MODALS = {
    VIEWS_LIMITS_MODAL: 'VIEWS_LIMITS_MODAL',
    STORAGE_LIMITS_MODAL: 'STORAGE_LIMITS_MODAL',
    PROJECTS_LIMITS_MODAL: 'PROJECTS_LIMITS_MODAL',
    PDF_GENERATION: 'PDF_GENERATION',
}
